import { render, staticRenderFns } from "./InfoGraphics.vue?vue&type=template&id=0b87b3b7&"
import script from "./InfoGraphics.vue?vue&type=script&lang=js&"
export * from "./InfoGraphics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports